<template>
    <mySubPage>
        <div slot="header">
            <myNav>新增用户</myNav>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="100px">
            <el-form-item :label="$t('logo_img')">
                <myCropImg :autoCropWidthHeight="[230,230]" crop_height="350px" crop_width="350px" @cropImgUpload="setImgLnk"></myCropImg>
            </el-form-item>
            <el-form-item :label="$t('wx_img_lnk')">
                <img class="width-100" :src="formData.wx_img_lnk" v-if="formData.wx_img_lnk != ''">
                <myUpImg @onChange="setWxImgLnk"></myUpImg>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('select_dep')" prop="dep_id">
                        <el-select class="fillw" v-model="formData.dep_id" :placeholder="$t('select')">
                            <el-option :label="item.dep_cname"  :value="item.dep_id" v-for="(item, index) in deps" :key="item.dep_id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('select_role')" prop="role_id">
                        <el-select class="fillw" v-model="formData.role_id" :placeholder="$t('select')">
                            <el-option :label="item.role_cname"  :value="item.role_id" v-for="(item, index) in roles" :key="item.role_id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item  :label="$t('user_code')" prop="user_code">
                        <el-input v-model="formData.user_code" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item  :label="$t('user_cname')" prop="user_cname">
                        <el-input v-model="formData.user_cname" :placeholder="$t('input')"></el-input>
                        <input style="width: 0;height:0;border: 0;float: left" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('pwd')" prop="show_user_pwd">
                        <input style="width: 0;height:0;border: 0;float: left" type="password" />
                        <el-input v-model="formData.show_user_pwd"  type="password" :placeholder="$t('input')" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('chk_pwd')" prop="chk_pwd">
                        <el-input v-model="formData.chk_pwd"  type="password" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('mobile')" prop="user_mobile">
                        <el-input v-model="formData.user_mobile" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item  :label="$t('birth')" prop="user_birth">
                        <el-date-picker type="date" v-model="formData.user_birth" :placeholder="$t('input')" :editable="false"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('sex')" prop="user_sex">
                        <el-radio-group v-model="formData.user_sex">
                            <el-radio v-for="item in sexs" :key="item.key" :label="item.key">{{item.value}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    import myCropImg from '../../../components/myCropImg'
    import myUpImg from '../../../components/myUpImg'
    export default {
        components: {
            myCropImg,
            myUpImg
        },
        data:function(){
            return{
                relist: false,
                formData: {
                    img_lnk:'',
                    wx_img_lnk:'',
                    user_cname: '',
                    user_mobile: '',
                    dep_id: '',
                    role_id:'',
                    user_sex: '0',
                    user_birth: '',
                    user_code: '',
                    show_user_pwd:'',
                    user_pwd:'',
                    chk_pwd: ''
                },
                rule: {
                    user_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    user_mobile: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    dep_id: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    role_id: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    user_sex: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    user_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    show_user_pwd: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    chk_pwd: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                },
                deps: [],
                roles: [],
                sexs:[],
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.getLoad();
        },
        methods:{
            setImgLnk: function (file_path) {
                this.formData.img_lnk = file_path;
            },
            setWxImgLnk: function (data){
                this.formData.wx_img_lnk = data.url;
            },
            cancel: function(){
                this.$base.linkBack();
            },
            getLoad: function(){
                this.$base.showLoading();
                this.$request.sendPost("user/before-add",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.deps = data.deps;
                        this.roles = data.roles;
                        this.sexs =data.sexs;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        if(this.formData.chk_pwd != this.formData.show_user_pwd) {
                            this.$base.alertErr(this.$t('user_pwd_err'));
                            return;
                        }
                        this.formData.user_pwd = this.$base.toMD5(this.formData.show_user_pwd);
                        if(this.formData.user_birth) {
                            this.formData.user_birth = this.$moment(this.formData.user_birth).format("YYYY-MM-DD");
                        }
                        this.$base.showLoading();
                        this.$request.sendPost("user/add",this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/user/user_add.vue